import { render, staticRenderFns } from "./dependencias.vue?vue&type=template&id=2e1e9f94"
import script from "./dependencias.vue?vue&type=script&lang=js"
export * from "./dependencias.vue?vue&type=script&lang=js"
import style0 from "./dependencias.vue?vue&type=style&index=0&id=2e1e9f94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports